import { render } from "./Soporte.vue?vue&type=template&id=6fd56ccd&scoped=true"
import script from "./Soporte.vue?vue&type=script&lang=js"
export * from "./Soporte.vue?vue&type=script&lang=js"

import "./Soporte.vue?vue&type=style&index=0&id=6fd56ccd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fd56ccd"]])

export default __exports__